// HealthandWellnessTracker.js
import React from "react";
import Login from "../../../assets/HW/HW_Login.png";
import SignUp from "../../../assets/HW/HW_SignUp.png";
import Profile from "../../../assets/HW/HW_Profile.png";
import Record from "../../../assets/HW/HW_Record.png";
import Manage from "../../../assets/HW/HW_Manage.png";
import Logo from "../../../assets/HW/HW_Logo.png";
import Graph from "../../../assets/HW/HW_Graph.png";
import Goal from "../../../assets/HW/HW_Goal.png";

const HealthandWellnessTracker = () => {
  return (
    <div className="pt-16 mx-3 md:mx-8">
      <h1 className="text-4xl mb-8 font-black text-lightBrown md:text-6xl md:mb-16 ">
        Health and Wellness Tracker
      </h1>
      <div className="mx-4 md:mx-0">
        {/*---------------------------- mobile view table ----------------------------*/}
        <table
          className="md:hidden mx-2 my-4 text-sm"
          style={{ borderSpacing: "1 0" }}
        >
          <tbody>
            <tr>
              <td className=" p-1 align-top w-1/2">
                <h2 className="font-bold underline">ROLE</h2>
                <p> Design & Implementation Leader</p>
              </td>
              <td className=" p-1 align-top w-1/2">
                <h2 className="underline font-bold ">RESPONSIBILITIES</h2>
                <p>
                  Designed User Interface using Figma, Developed dynamic web
                  pages using React and Material UI
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        {/*---------------------------- project overview ----------------------------*/}
        <p className="text-center text-lg py-4 md:py-0 md:mb-4 md:text-left md:mx-10 md:text-2xl">
          This web application was developed as part of a university project. It
          is designed to help users track their health and wellness, such as
          steps taken, water intake, sleep, exercise routines, and diet. Users
          can set daily and weekly goals in each of these areas and monitor
          their progress toward achieving their goals.
        </p>

        {/*---------------------------- desktop view table ----------------------------*/}
        <table
          className="hidden md:block border-separate mx-[8%] py-8 "
          style={{ borderSpacing: "6rem 0" }}
        >
          <tbody>
            <tr>
              <td className="p-4 text-lg align-top w-1/2">
                <h2 className="font-bold text-xl underline">ROLE</h2>
                <p> Design & Implementation Leader</p>
              </td>
              <td className=" p-4 text-lg align-top w-1/2">
                <h2 className="underline font-bold text-xl">
                  RESPONSIBILITIES
                </h2>
                <p>
                  Designed User Interface using Figma, Developed dynamic web
                  pages using React and Material UI
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        {/*---------------------------- Logo ----------------------------*/}
        <div className="py-8">
          <h2 className="text-pink font-bold  text-center pb-4 text-xl md:text-2xl">
            {" "}
            - - Logo Story - -
          </h2>
          <div className=" md:flex md:gap-6">
            <div className="w-1/3 md:w-2/3">
              <img
                src={Logo}
                alt="HWT logo"
                className=" rounded-xl object-contain w-full max-w-full h-auto float-left mr-4 "
              />
            </div>

            <div className="pt-1 md:pt-0 md:flex md:items-center">
              {" "}
              <p className="text:lg md:text-xl">
                Driven by curiosity and a strong interest, I took the initiative
                to self-teach Figma. This project marked the first time I used
                my self-taught skills to design a logo for a team collaboration,
                and I couldn’t have been happier with the experience. To my
                delight, the team loved my design! While I may look back on it
                someday and see it as a beginner's attempt, I will always
                cherish the sense of accomplishment and recognition I felt when
                others appreciated my work.
              </p>
            </div>
          </div>
        </div>

        {/*---------------------------- web demo ----------------------------*/}
        <div className="py-8">
          <h2 className="text-pink font-bold  text-center pb-4 text-xl md:text-2xl">
            {" "}
            - - Website Snapshot - -
          </h2>
          <img src={Login} alt="HWTracker Login" className="mb-8 rounded-xl" />
          <img
            src={SignUp}
            alt="HWTracker SignUp"
            className="mb-8 rounded-xl"
          />
          <img src={Graph} alt="HWTracker Graph" className="mb-8 rounded-xl" />
          <img
            src={Record}
            alt="HWTracker Record"
            className="mb-8 rounded-xl"
          />
          <img
            src={Manage}
            alt="HWTracker Manage"
            className="mb-8 rounded-xl"
          />
          <img src={Goal} alt="HWTracker Goal" className="mb-8 rounded-xl" />
          <img
            src={Profile}
            alt="HWTracker Profile"
            className="mb-8 rounded-xl"
          />
        </div>
      </div>
    </div>
  );
};
export default HealthandWellnessTracker;
